<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app",
  components: {},
};
</script>

<style lang="less">
#app {
  font-family: "Microsoft YaHei Bold";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px;
}
// 修改popover的样式
.el-popover {
  //   left: 1116px !important;
  padding: 26px 24px 6px !important;
  /deep/ .popper__arrow {
    // left: 315px !important;
  }
  .title {
    margin-bottom: 18px;
    span {
      &:nth-child(1) {
        color: #333;
      }
      &:nth-child(2) {
        color: #909399;
      }
    }
  }
  .box {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .tt {
      position: relative;
      margin-right: 16px;
      margin-bottom: 20px;
      &:nth-child(5n) {
        margin-right: 0;
      }
      .wnld {
        width: 36px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border-radius: 4px;
        background-color: #fa8c15;
        color: #fff;
      }
      > img {
        position: absolute;
        top: -8px;
        right: -8px;
      }
    }
  }
}
// 已购买测评
.shool_mng_popover {
  left: 980px !important;
  /deep/ .popper__arrow {
    left: 242px !important;
  }
}
// 未购买测评
.shool_mng_unpay {
  left: 1090px !important;
  /deep/ .popper__arrow {
    left: 348px !important;
  }
  .box {
    .tt {
      &:nth-child(5n) {
        margin-right: 16px;
      }
      &:nth-child(7n) {
        margin-right: 0;
      }
    }
  }
}

// 有测评
.shool_train_popover {
  left: 1153px !important;
  /deep/ .popper__arrow {
    left: 257px !important;
  }
}
//   无测评
.unshool_train_popover {
  left: 1028px !important;
  /deep/ .popper__arrow {
    left: 362px !important;
  }
  .box {
    .tt {
      &:nth-child(5n) {
        margin-right: 16px;
      }
      &:nth-child(7n) {
        margin-right: 0;
      }
    }
  }
}
.unshoolTrain_popover {
  padding: 20px 16px 20px !important;
  left: 900px !important;
  /deep/ .popper__arrow {
    left: 184px !important;
  }
  .title {
    margin-bottom: 14px;
  }
  .box {
    .tt {
      position: relative;
      margin-right: 0px;
      margin-bottom: 0px;
      border-bottom: 1px solid #dcdfe6;
      border-right: 1px solid #dcdfe6;
       width: 36px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      &:hover {
        background-color: #1fb0ff;
        color: #fff;
      }

      &:nth-child(-n + 5) {
        border-top: 1px solid #dcdfe6;
      }
      &:nth-child(5n + 1) {
        border-left: 1px solid #dcdfe6;
      }
     
    }
  }
}
// 县培
.area_popover {
  left: 1063px !important;
  padding: 20px 16px 20px !important;
  /deep/ .popper__arrow {
    left: 220px !important;
  }
  .title {
    margin-bottom: 14px;
  }
  .box {
    .tt {
      position: relative;
      margin-right: 0px;
      margin-bottom: 0px;
      border-bottom: 1px solid #dcdfe6;
      border-right: 1px solid #dcdfe6;
      width: 36px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      &:hover {
        background-color: #1fb0ff;
        color: #fff;
      }
      &:nth-child(-n + 6) {
        border-top: 1px solid #dcdfe6;
      }
      &:nth-child(6n + 1) {
        border-left: 1px solid #dcdfe6;
      }
      /*> div {
        border-radius: 0px;
        background-color: #fff;
        color: #333;
      }*/
    }
  }
}
// 校管理提升清单
.schoolpromote_popover {
  padding: 20px 16px 20px !important;
  left: 840px !important;
  /deep/ .popper__arrow {
    left: 229px !important;
  }
  .title {
    margin-bottom: 14px;
  }
  .box {
    .tt {
      position: relative;
      margin-right: 0px;
      margin-bottom: 0px;
      border-bottom: 1px solid #dcdfe6;
      border-right: 1px solid #dcdfe6;
      width: 36px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      &:hover {
        background-color: #1fb0ff;
        color: #fff;
      }

      &:nth-child(-n + 6) {
        border-top: 1px solid #dcdfe6;
      }
      &:nth-child(6n + 1) {
        border-left: 1px solid #dcdfe6;
      }
      /* > div {
        border-radius: 0px;
        background-color: #fff;
        color: #333;
        &:hover {
          background-color: #1fb0ff;
          color: #fff;
        }
      }*/
    }
  }
}
.promote_popper {
  left: 1105px !important;
  /deep/ .popper__arrow {
    left: 309px !important;
  }
  .box {
    .tt {
      &:nth-child(5n) {
        margin-right: 16px;
      }
      &:nth-child(6n) {
        margin-right: 0;
      }
    }
  }
}
</style>
